import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// Component
import FormComponent from "./Form";

// css
import * as styles from "./RegisterForm.module.css";

const RegisterFormComponent = props => {
  // Animation On Scroll
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"} ${
          styles.diabConsLp__form__cont
        }`}
      >
        <div className="row">
          <div
            className={`col-12 col-md-6 col-lg-6 order-1 order-md-2 order-lg-2`}
          >
            <div className={`${styles.diabConsLp__form__bannerImg}`}>
              <StaticImage
                src="../../../../images/LandingPage/formImg.png"
                alt="banner_image"
                className="img-fluid"
                placeholder="blurred"
                quality={90}
              />
            </div>
          </div>
          <div
            className={`col-12 col-md-6 col-lg-6 text-center order-2 order-md-1 order-lg-1`}
          >
            <FormComponent
              mixpanelPageName={props.mixpanelPageName}
              formDataToLsq={props.formDataToLsq}
              formHeading={props.formHeading}
              loading={props.loading}
              ctaText={props.ctaText}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterFormComponent;
